import { useState, useEffect } from 'react';

export const useAuthenticatedImage = (url: string | undefined) => {
    const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!url) {
            setImageUrl(undefined);
            return;
        }
        setImageUrl(url);
    }, [url]);

    return { imageUrl, isLoading, error };
};
